import Stack from "@mui/material/Stack";
import { useAgreementContext } from "../AgreementContext";
import { AgreementSummary } from "../components/AgreementSummary";
import AgreementTagsWrapper from "../components/AgreementTagsWrapper";
import { SchedulesTable } from "../components/SchedulesTable";
import { useSchedules } from "../hooks/useSchedules";
import { Reschedule } from "../reschedule/Reschedule";

const EditAgreement = () => {
  const agreement = useAgreementContext();
  const schedules = useSchedules(agreement.id);
  const currentSchedule = schedules.schedules?.find(
    (schedule) => schedule.status === "open" || schedule.status === "settled"
  );
  return (
    <Stack spacing={5} sx={{ px: 5, mb: 5 }}>
      <AgreementSummary agreement={agreement} />
      <AgreementTagsWrapper agreement={agreement} />
      <SchedulesTable agreement={agreement} {...schedules} />
      {currentSchedule && currentSchedule.status === "open" && (
        <Reschedule agreement={agreement} schedule={currentSchedule} />
      )}
    </Stack>
  );
};

export default EditAgreement;
